import { SingularConfig, singularSdk } from 'singular-sdk';

import { EventProps, TrackerConfig, TrackerEvent, UserEvent } from '../../types/services';

import { SingularBaseLink } from 'common/config/constants/urls';

import { trackEvents } from '../../config/events';

class SingunlarTracker extends TrackerEvent {
  private _singularDeviceId: string | null = null;

  public get singularDeviceId(): string | null {
    return this._singularDeviceId;
  }
  public set singularDeviceId(value: string | null) {
    this._singularDeviceId = value;
  }
  valid = (key: keyof TrackerConfig) => {
    return trackEvents.singular.enabled && trackEvents.singular[key];
  };

  init = () => {
    if (this.valid('enabled')) {
      const config = new SingularConfig(
        process.env.REACT_APP_SINGULAR_SDK_KEY,
        process.env.REACT_APP_SINGULAR_SDK_SECRET,
        'com.astropay.app',
      )
        .withAutoPersistentSingularDeviceId('astropay.com')
        .withInitFinishedCallback((initParams: { singularDeviceId: string }) => {
          this.singularDeviceId = initParams.singularDeviceId;
        });
      singularSdk.init(config);
      singularSdk.logout();
    }
  };

  trackUser = (user: UserEvent) => {
    if (this.valid('user')) {
      singularSdk.login(user.id_external);
    }
  };

  trackEvent = (eventName: string, props?: EventProps) => {
    if (this.valid('event')) {
      singularSdk.event(eventName, props);
    }
  };

  getUrlToDownloadApp = () => {
    return singularSdk.buildWebToAppLink(SingularBaseLink, 'home');
  };
}

export default new SingunlarTracker();
